export enum EventAlteration {
  RESCHEDULE = 'RESCHEDULE',
  CANCEL = 'CANCEL'
}
export enum AppointmentOwner {
  VIRGILIO = 'Virgilio',
  ROMAIN = 'Romain'
}
